/**
 * @generated SignedSource<<690118cf7a65320e213a3256c2e353e5>>
 * @relayHash 9254794c81eab73d38a4fcd183545b44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e7eaadf0b4bc99fcf00cfa29d947f83ace3effa8dc03c1cd6d9d8e435d7881a6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type parentIssueTransitionIssueAdjustmentsQuery$variables = {
  ari: string;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
};
export type parentIssueTransitionIssueAdjustmentsQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly parentCandidatesForExistingIssue?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fieldsById: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly fieldId?: string;
                readonly issueType?: {
                  readonly avatar: {
                    readonly xsmall: string | null | undefined;
                  } | null | undefined;
                  readonly hierarchy: {
                    readonly level: number | null | undefined;
                  } | null | undefined;
                  readonly issueTypeId: string | null | undefined;
                  readonly name: string;
                } | null | undefined;
                readonly status?: {
                  readonly statusCategory: {
                    readonly statusCategoryId: string;
                  } | null | undefined;
                };
                readonly text?: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly issueColorField: {
            readonly color: {
              readonly colorKey: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly key: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type parentIssueTransitionIssueAdjustmentsQuery = {
  response: parentIssueTransitionIssueAdjustmentsQuery$data;
  variables: parentIssueTransitionIssueAdjustmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterById"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ari"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "Literal",
    "name": "excludeDone",
    "value": false
  },
  {
    "kind": "Variable",
    "name": "filterById",
    "variableName": "filterById"
  },
  {
    "kind": "Literal",
    "name": "searchBy",
    "value": ""
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v6 = [
  {
    "kind": "Literal",
    "name": "ids",
    "value": [
      "summary",
      "issuetype",
      "status"
    ]
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
},
v9 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v10 = {
  "kind": "ScalarField",
  "name": "name"
},
v11 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v12 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v14 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "parentIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "parentCandidatesForExistingIssue",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "JiraColorField",
                            "kind": "LinkedField",
                            "name": "issueColorField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/)
                                ]
                              }
                            ]
                          },
                          {
                            "args": (v6/*: any*/),
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              (v11/*: any*/),
                                              (v12/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssueTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                  (v13/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraStatusField"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraParentIssueField"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "parentIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v14/*: any*/),
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "parentCandidatesForExistingIssue",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          (v4/*: any*/),
                          {
                            "concreteType": "JiraColorField",
                            "kind": "LinkedField",
                            "name": "issueColorField",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "color",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v2/*: any*/)
                                ]
                              },
                              (v2/*: any*/)
                            ]
                          },
                          {
                            "args": (v6/*: any*/),
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fieldsById",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v14/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              (v9/*: any*/),
                                              (v10/*: any*/),
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              (v2/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssueTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v7/*: any*/),
                                          {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraStatusCategory",
                                                "kind": "LinkedField",
                                                "name": "statusCategory",
                                                "plural": false,
                                                "selections": [
                                                  (v13/*: any*/),
                                                  (v2/*: any*/)
                                                ]
                                              },
                                              (v2/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraStatusField"
                                      },
                                      (v2/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraParentIssueField"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e7eaadf0b4bc99fcf00cfa29d947f83ace3effa8dc03c1cd6d9d8e435d7881a6",
    "metadata": {},
    "name": "parentIssueTransitionIssueAdjustmentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "80f30b7afe9a71b36db44f64eef395cf";

export default node;
